import status from './status'
import getCurrencies from './get-currencies'
import getEstimatePrice from './get-estimate-price'
import createPayment from './create-payment'
import getPaymentStatus from './get-payment-status'
import getMinimumPaymentAmount from './get-minimum-payment-amount'
import getListPayments from './get-list-payments'
import createInvoice from './create-invoice'

export default {
  status,
  getCurrencies,
  getEstimatePrice,
  createPayment,
  getPaymentStatus,
  getMinimumPaymentAmount,
  getListPayments,
  createInvoice
}
